import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import {withRouter} from 'react-router-dom';

import Filters from "../components/Filters";
import * as actions from '../sample.actions';
import {NFSampleDataGrid} from "../components";
import * as selectors from '../sample.selectors';
import {WarningButton, PrimaryButton} from '../../../components'

const Container = styled.div`
    padding: 4px 4px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 5px;
    margin-top: 5px;
`;

class NFViewContainer extends React.Component {

  onPatientClick = (recordId) => () =>
    this.props.history.push(`/records/${this.props.period.id}/${recordId}/uploads`);

  gridActions = ({data: {id, recordStatusValue}}) => {
    const Button = recordStatusValue >= 3 ? PrimaryButton : WarningButton;
    return (
      <div>
        <Button onClick={this.onPatientClick(id)}>
          {recordStatusValue >= 3 ? 'View' : 'Upload'}
        </Button>
      </div>
    );
  };

  render() {
    const {facilities, patients} = this.props;

    return (
      <Container>

        <Filters
          filters={this.props.filters}
          facilities={facilities}
          search={this.props.actions.setFilters}
          clear={this.props.actions.clearFilters}
        />
        <NFSampleDataGrid patients={patients} actionsRenderer={this.gridActions}/>
      </Container>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      filters: selectors.filters(state),
      period: selectors.currentPeriod(state),
      patients: selectors.includedPatients(state),
      facilities: selectors.facilities(state),
    }),
    dispatch => ({
      actions: bindActionCreators({...actions}, dispatch)
    })
  )(NFViewContainer)
);



// WEBPACK FOOTER //
// ./src/modules/sample/admin/NFViewContainer.js